const nf = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const fmtNum = (v) => (v === null || v === undefined || Number.isNaN(v) ? "–" : nf.format(v));
export const fmtEUR = (v) => (v === null || v === undefined ? "–" : `${nf.format(v)} €`);
export const fmtSigned = (v) => (v === null || v === undefined ? "–" : `${v > 0 ? "+" : ""}${nf.format(v)} €`);

export const fmtDate = (iso) => {
  if (!iso) return "–";
  const [y, m, d] = iso.slice(0, 10).split("-");
  return `${d}.${m}.${y}`;
};

export const parseAmount = (s) => {
  if (s === null || s === undefined) return null;
  let t = String(s).trim().replace(/€|\s/g, "");
  if (!t) return null;
  const neg = t.endsWith("-") || t.startsWith("-");
  t = t.replace(/^[-+]|-$/g, "");
  if (t.includes(",")) t = t.replace(/\./g, "").replace(",", ".");
  const v = parseFloat(t);
  if (Number.isNaN(v)) return null;
  return neg ? -v : v;
};

export const toInputAmount = (v) => (v === null || v === undefined ? "" : nf.format(v).replace(/\./g, ""));

export const STATUS_LABELS = {
  offen: { label: "Offen", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  beleg_vorhanden: { label: "Beleg vorhanden", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  kein_beleg_noetig: { label: "Kein Beleg nötig", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  eigenbeleg: { label: "Eigenbeleg", cls: "bg-blue-50 text-blue-800 border-blue-200" },
};

export const firstLine = (s) => (s || "").split("\n")[0];

export const fmtDateTime = (iso) => {
  if (!iso) return "–";
  return new Intl.DateTimeFormat("de-AT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: "Europe/Vienna" }).format(new Date(iso));
};
